import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Routes } from '../../app/routes';

export const useGoBack = (fallbackRoute = Routes.SignRequests) => {
  const location = useLocation();
  const [previousLocation, setPreviousLocation] = useState(location.state?.from || null);

  useEffect(() => {
    if (location.state?.from) {
      setPreviousLocation(location.state.from);
    }
  }, [location.state]);

  return previousLocation ? previousLocation.pathname + previousLocation.search : fallbackRoute;
};
